import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { LOAD_ANALYTIC } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AnalyticDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadAnalytic =
  (
    id: number | string,
  ): ThunkAction<Promise<void>, State, null, AnalyticDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: LOAD_ANALYTIC + REQUEST });
    try {
      const payload = await api.loadAnalytic(id);
      dispatch({ type: LOAD_ANALYTIC + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: LOAD_ANALYTIC + FAILURE, error });
    }
  };

export const loadAnalyticIdle = () => ({ type: LOAD_ANALYTIC + IDLE });
